// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".guide-simple-list .list-type{height:2px}.guide-simple-list .p-wrapper{width:calc(100% - 30px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
